import { createStore } from 'owa-satcheljs';
import { PrioritizeRequestStatus } from './PrioritizeRequestStatus';
import { type MailboxInfo, getAccountKeyForMailboxInfo } from 'owa-client-types';
import type { PriorityInboxStoreData } from './schema/PriorityInboxStore';
import { getLogicalRing } from 'owa-config';
import { hasQueryStringParameter } from 'owa-querystring';

interface PriorityInboxStore {
    priorityInboxMap: Map<string, PriorityInboxStoreData>;
}

const priorityInboxStoreMap: PriorityInboxStore = {
    priorityInboxMap: new Map<string, PriorityInboxStoreData>(),
};

export const getStore: () => PriorityInboxStore = createStore<PriorityInboxStore>(
    'priorityInbox',
    priorityInboxStoreMap
);

export function getUserStore(mailboxInfo: MailboxInfo): PriorityInboxStoreData {
    const accountKeyForMailboxInfo = getAccountKeyForMailboxInfo(mailboxInfo);
    const store = getStore();

    let cachedUserStore = store.priorityInboxMap.get(accountKeyForMailboxInfo);
    if (!cachedUserStore) {
        const defaultUserStore = {
            prioritizeRequestStatus:
                getLogicalRing() === 'Dogfood' && hasQueryStringParameter('forcePrioritizeNudge')
                    ? PrioritizeRequestStatus.Nudged
                    : PrioritizeRequestStatus.None,
            loadingMessageIndex: 0,
            requestNumber: 0,
            skippedRowKeys: [],
            previousTableQuery: undefined,
            priorityTableViewId: undefined,
            debugOutput: undefined,
            hasUnprocessedRows: false,
            priorityViewEnteredTimestamp: undefined,
            inProgressStartTimestamp: undefined,
            readyTimestamp: undefined,
            viewOpenedContext: undefined,
            prioritizeRunId: undefined,
            prioritizeSource: undefined,
        };

        store.priorityInboxMap.set(accountKeyForMailboxInfo, defaultUserStore);

        cachedUserStore = store.priorityInboxMap.get(accountKeyForMailboxInfo) ?? defaultUserStore;
    }

    return cachedUserStore;
}
